import { NavigationEntity } from "domain/entity/Navigation";
import _ from "lodash";

export const retrieveUniqueMFENavigation = (navigation: NavigationEntity[]): NavigationEntity[] => {
    const flattenNavigations = navigation.flatMap(test => test.submenu ?? test).flatMap(test => test.submenu ?? test)
    const realMFENavigations = flattenNavigations.filter((menuItem) => menuItem.entrypoint)
    const uniqueMFENavigations = _.uniqBy(realMFENavigations, 'title')
    return uniqueMFENavigations
}